import React from 'react';
import PropTypes from 'prop-types';
import { StyledLoader } from './styled';
import LoaderImage from '../LoaderImage';

const Loader = ({ show }) => {
    return (
        <StyledLoader
            show={show}
        >
           <LoaderImage />
        </StyledLoader>
    );
};

Loader.propTypes = {
    show: PropTypes.bool
};

Loader.defaultProps = {
    show: false
};

export default React.memo(Loader);